
import { useContext, useEffect, useState } from 'react';
import "./AchieversGallery.scss";
import { AppContext } from '../../context/AppContext';
import axios from 'axios';
import { toast } from 'react-toastify';

const AchieversGallery = () => {

    const { backendUrl } = useContext(AppContext);
    const [allAchieversDetails, setAllAchieversDetails] = useState([]);

        async function fetchAllAchieversDetails() {
        try {
            const { data } = await axios.get(`${backendUrl}/api/auth/getAllAchieversImages`);
            if (data.success) {
                setAllAchieversDetails(data || []);
            } 
        } catch (error) {
           if (error.response && error.response.status === 503) {
                           toast.error("⚠️ The service is currently under maintenance. Please try again later.");
                       }
                       else if (!navigator.onLine) {
                           toast.error("🚫 No internet connection. Please check your network.");
                       }
           
                       else if (error.request && !error.response) {
                           toast.error("⚠️ Network issue or server is unreachable. Try again later.")
                       }
                       else 
                       {
                           console.error("Unexpected error:", error);
                           toast.error("Something went wrong.");
                       }
        }
    }

    useEffect(() => {
        fetchAllAchieversDetails();
    }, []);


    return (
        <section className="achieversGalleryMainContainer">
            <header>
                <h2>Achievers Gallery</h2>
            </header>
            <article className="achieversGallery gallery">
                {allAchieversDetails?.achieversDetails
                    ?.filter((achiever) => achiever.isActive).map((achiever, index) => (
                        <div className="imageParent image-container" key={index}>
                            <img
                                src={`data:${achiever.contentType};base64,${achiever.data}`}
                                alt={achiever.name}
                            />

                            {/* <div className="overlay">
                            <p>Name: {achiever.name}</p>
                            <p>Designation: {achiever.currentDesignation}</p>
                            <p>Batch: {achiever.batch}</p>
                            </div> */}

                            <div className="overlay">
                                {Object.entries(achiever)
                                    .filter(([key, value]) =>
                                        ![
                                            'data',
                                            'contentType',
                                            'id',
                                            '__v',
                                            'createdAt',
                                            'updatedAt',
                                            'isActive',
                                            'size',
                                            'filename'
                                        ].includes(key) && value !== "-" && value !== ""
                                    )
                                    .map(([key, value]) => {
                                        const formattedKey = key
                                            .replace(/([A-Z])/g, ' $1')
                                            .replace(/^./, str => str.toUpperCase());

                                        return (
                                            <p key={key}>
                                                {formattedKey}: {value}
                                            </p>
                                        );
                                    })}
                            </div>
                        </div>
                    ))}
            </article>
        </section>
    );
}

export default AchieversGallery;

